import { render, staticRenderFns } from "./TaskLinkInput.vue?vue&type=template&id=21ef2bf5&"
import script from "./TaskLinkInput.vue?vue&type=script&lang=js&"
export * from "./TaskLinkInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports